// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"f1851333","330":"f187c135","585":"fa9e8aca"}[chunkId] + ".chunk.js";
};